import { render, staticRenderFns } from "./EventCategoryTag.vue?vue&type=template&id=03c0915f&"
import script from "./EventCategoryTag.vue?vue&type=script&lang=ts&"
export * from "./EventCategoryTag.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports